const MASKS = {
  phone: {
    name: "Phone number",
    fn: "phone",
    props: {}
  },
  onlyNumbers: {
    name: "Numeric characters only",
    fn: "onlyNumbers",
    props: {
      commas: {type: "checkbox", value: false, label: "Separate numbers with commas"},
      leadingZerosAllowed: {type: "checkbox", value: true, label: "Allow leading zeros"},
      allowDecimal: {type: "checkbox", value: false, label: "Allow a decimal"}
    }
  },
  fein: {
    name: "Federal employer identification number",
    fn: "fein",
    props: {}
  },
  currency: {
    name: "American currency",
    fn: 'currency',
    props: {
      commas: {type: "checkbox", value: true, label: "Separate numbers with commas"}
    }
  },
  maxStringLength: {
    name: "Character Limit",
    fn: 'maxStringLength',
    props: {
      max: {type: "text", value: 100, label: "Max number of characters allowed"}
    }
  },
  onlyAscii: {
    name: "Only allow ASCII characters 32 through 126",
    fn: 'onlyAscii',
    props: {}
  },
  zipCode: {
    name: "ZIP code",
    fn: 'zipCode',
    props: {}
  },
  addressZipCode: {
    name: "Address ZIP code",
    fn: 'addressZipCode',
    props: {}
  },
  social: {
    name: "Social Security Number",
    fn: 'social',
    props: {}
  },
  allUpperCase: {
    name: "Force uppercase text",
    fn: 'allUpperCase',
    props: {}
  },
  addressUpperCase: {
    name: "Address force uppercase text",
    fn: 'addressUpperCase',
    props: {}
  },
  onlyAsciiConfirmFields: {
    name: 'Only allow ASCII characters 32 through 126',
    fn: 'onlyAsciiConfirmFields',
    props: {}
  },
  time: {
    name: '12-hour Time',
    fn: 'time',
    props: {}
  }
}
export default MASKS



// WEBPACK FOOTER //
// ./src/components/Wizard2/masks.js